import React, { FC } from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router-dom';
import PruRoute from '../../../../../common/components/PruRoute';
import SalesMPerformanceTrackingListingPage from './List/SalesMPerformanceTrackingListingPage';
import ParamsProvider from '../../../../../common/components/ParamsProvider';
import { reportFilterKeys } from '../../../constants';

const SalesMPerformanceTrackingPage: FC<RouteComponentProps> = ({ match }) => {
  return (
    <Switch>
      <Redirect exact from={match.path} to={`${match.path}/list`}/>
      <PruRoute
        exact
        path={`${match.path}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={reportFilterKeys}>
            <SalesMPerformanceTrackingListingPage />
          </ParamsProvider>
        )}
      />
    </Switch>
  )
};

export default SalesMPerformanceTrackingPage;
